import { render, staticRenderFns } from "./ManualRulesGridAssign.vue?vue&type=template&id=6113ed69&scoped=true&"
import script from "./ManualRulesGridAssign.vue?vue&type=script&lang=ts&"
export * from "./ManualRulesGridAssign.vue?vue&type=script&lang=ts&"
import style0 from "./ManualRulesGridAssign.vue?vue&type=style&index=0&id=6113ed69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113ed69",
  null
  
)

export default component.exports